// extracted by mini-css-extract-plugin
export default {"container":"lBv2XN","name":"dlINDG"};